var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"#","before-upload":_vm.beforeUpload,"show-file-list":false}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("导入excel")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }